import React from 'react'
import styled from 'styled-components'
import { FormField } from '../../form/FormField/FormField'
import { Tag } from '../../misc/Tag/Tag'

export type TagItem = {
  id: string
  title: React.ReactNode
}

const WrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const TagList: React.FC<{
  name?: string
  list: TagItem[]
  onRemove?: (tag: TagItem) => void
  label?: string
  className?: string
}> = ({ list, onRemove, label, name, className }) => {
  return (
    <FormField
      name={name}
      label={label}
      render={() => (
        <WrapperStyled className={className}>
          {list.map(tag => (
            <Tag key={`tag-${tag.id}`} title={tag.title} index={tag.id} onRemove={() => onRemove?.(tag)} />
          ))}
        </WrapperStyled>
      )}
    />
  )
}
